import { auth } from "../../firebase";

export default async function signInFirebase({ email, password, errorCallback, setLoading }) {
  errorCallback(null);
  setLoading(true);
  auth
    .signInWithEmailAndPassword(
      email,
      password
    )
    .then((user) => {
      // home page will load automatically by firebase
    })
    .catch((error) => {
      console.error(error);
      errorCallback(error.message);
    })
    .finally(() => {
      setLoading(false);
    });
}